import axios from "axios";

import { API_URL } from "@/config/constants";

import { ITemplateRenderSummary } from "./template-renders.types";

const rendersUrl = (conversationId: number) =>
    `${API_URL}/chat/conversations/${conversationId}/renders`;

export const getConversationRenders = async (conversationId: number) => {
    const result = await axios.get<ITemplateRenderSummary[]>(
        rendersUrl(conversationId)
    );
    return result.data;
};

export const retryRender = async (conversationId: number, renderId: number) => {
    const result = await axios.post<ITemplateRenderSummary>(
        `${rendersUrl(conversationId)}/${renderId}/retry`
    );
    return result.data;
};
